export default "__VITE_ASSET__DoCNQ31F__"